import { render, staticRenderFns } from "./datosPersonales.vue?vue&type=template&id=751af0ba&scoped=true&"
import script from "./datosPersonales.vue?vue&type=script&lang=js&"
export * from "./datosPersonales.vue?vue&type=script&lang=js&"
import style0 from "./datosPersonales.vue?vue&type=style&index=0&id=751af0ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751af0ba",
  null
  
)

export default component.exports